import { useWebViewAuth } from "@/components/AuthProvider";
import { Header } from "@/components/landing/Header";
import { FooterSection } from "@/components/landing/FooterSection";
import { PopularRoutesPreFooter } from "@/components/landing/PopularRoutesPreFooter";
import { Outlet, useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "@/routes/routePaths";

/** Public detail pages that use a minimal chrome (no pre-footer or site footer). */
const FOOTERLESS_PATHS = new Set<string>([
  ROUTE_PATHS.RIDE_INFO,
  ROUTE_PATHS.BOOKING_INFO,
  ROUTE_PATHS.FIND_RIDE,
]);

type HeaderProps = {
  onAuthClick: (mode: "login" | "register") => void;
  selectedCountry: string;
  onCountryChange: (country: string) => void;
};

type FooterProps = {
  showAuthModal?: boolean;
  setShowAuthModal?: (show: boolean) => void;
  setAuthMode?: (mode: "login" | "register") => void;
};

/**
 * Site chrome — one header/footer for every page (public + private).
 */
const Layout = ({
  showFooter = true,
  showHeader = true,
  headerProps,
  footerProps = {},
}: {
  showFooter?: boolean;
  showHeader?: boolean;
  headerProps: HeaderProps;
  footerProps?: FooterProps;
}) => {
  const { webViewAuth } = useWebViewAuth();
  const location = useLocation();
  const hideSiteFooter = FOOTERLESS_PATHS.has(location.pathname);
  const isNativeWebView =
    webViewAuth.isNativeWebView ||
    (typeof window !== "undefined" &&
      sessionStorage.getItem("isNativeWebView") === "true");

  return (
    <>
      {!isNativeWebView && showHeader && <Header {...headerProps} />}
      <main>
        <Outlet />
      </main>
      {!isNativeWebView && showFooter && !hideSiteFooter && (
        <PopularRoutesPreFooter />
      )}
      {!isNativeWebView && showFooter && !hideSiteFooter && (
        <FooterSection {...footerProps} />
      )}
    </>
  );
};

export default Layout;
